import React from "react";
import "./RelatorioPreview.scss";

const RelatorioPreview = ({ medicamentos }) => {
  return (
    <div className="relatorio-preview">
      <h3>Medicamentos Cadastrados</h3>
      
      {medicamentos && medicamentos.length > 0 ? (
        <div className="medicamentos-list">
          {medicamentos.map((medicamento) => (
            <div key={medicamento.id} className="medicamento-item">
              <div className="header">
                <strong>{medicamento.nome || 'Sem nome'}</strong>
                <span>Dose: {medicamento.dosagem || 'Não informada'}</span>
              </div>
              <div className="details">
                <span>Frequência: {medicamento.frequencia || 'Não informada'}</span>
                {medicamento.descricao && <p>Obs: {medicamento.descricao}</p>}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="empty-message">Nenhum medicamento cadastrado</p>
      )}
    </div>
  );
};

export default RelatorioPreview;